export const checkDeviceInfo = (deviceInfo) => {
  return deviceInfo?.serial?.startsWith("MR4") || false;
};
